document.addEventListener('DOMContentLoaded', function () {
  const btn = document.getElementById('product-video-btn');
  const popup = document.getElementById('video-popup');
  const closeBtn = document.querySelector('.close-btn');

  if (btn && popup && closeBtn) {
    btn.addEventListener('click', () => popup.style.display = 'block');
    closeBtn.addEventListener('click', () => popup.style.display = 'none');
    window.addEventListener('click', (e) => {
      if (e.target === popup) popup.style.display = 'none';
    });
  }
});

